import React from "react";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SelectField} from "./FilterComponentStyles";

const AdjustmentTypeFilter = ({
    value,
    onChange,
    disabled = false,
    initialCall = true,
    mode = undefined,
    showAllOption = true,
    allowClear = true,
    label = "Eklenti/Kesinti Tipi",
    marginBottom = "20px",
    showLabel = true,
    placeholder = "Eklenti/Kesinti Tipi Seçin",
    type = undefined // "addition" veya "deduction" ile filtreleme yapılabilir
}) => {
    const stores = useStore();

    const [adjustmentTypesLoading, adjustmentTypes] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierAdjustmentStore.getAdjustmentTypes.bind(null, {
            type: type || undefined,
            limit: 1000
        }),
        dependencies: [type],
        initialCall: initialCall
    });

    const getOptions = () => {
        const data = adjustmentTypes?.data?.rows || [];
        return arrayAlphabeticalSort([...data], "name");
    };

    return (
        <React.Fragment>
            {showLabel && <h5>{label}</h5>}
            <SelectField
                showSearch
                data-testid="adjustmentTypeSelect"
                value={value}
                onChange={onChange}
                disabled={disabled || adjustmentTypesLoading}
                mode={mode}
                placeholder={placeholder}
                filterOption={(input, option) =>
                    option.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear={allowClear}
                mb={marginBottom}
                loading={adjustmentTypesLoading}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="option">
                        Tümü
                    </SelectField.Option>
                )}
                {getOptions().map(adjustmentType => (
                    <SelectField.Option
                        key={adjustmentType._id}
                        value={adjustmentType._id}
                        data-testid="adjustmentTypeSelect_option"
                    >
                        {adjustmentType.name}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default AdjustmentTypeFilter;

